import { useEffect, useState, useCallback } from 'react';
import { DrawerSvcc } from '../../../../components/drawer/DrawerSvcc';
import NewRadiologicalEquipmentDrawer from './NewRadiologicalEquipmentDrawer';
import useAlerts from '../../hooks/useAlerts';

export const RADIOLGICAL_EQUIPMENT_DRAWER_ACTION_VALUES = {
    NEW_RADIOLGICAL_EQUIPMENT: 'NEW_RADIOLGICAL_EQUIPMENT',
    EDIT_RADIOLGICAL_EQUIPMENT: 'EDIT_RADIOLGICAL_EQUIPMENT'
};

export enum EQUIPMENT_TAB_INDEX {
    EQUIPMENT = 0,
    DOSIMETRY = 1,
    RESPONSIBLES = 2
}

const DrawerManager = ({
    open,
    setOpen,
    selectedRadiologicalEquipment,
    translate,
    transformedRadilogicalEquipments,
    onlyVisual
}: any) => {
    const [currentTab, setCurrentTab] = useState<EQUIPMENT_TAB_INDEX>(
        EQUIPMENT_TAB_INDEX.EQUIPMENT
    );
    const { closeWithoutSavingAlert } = useAlerts({ translate: translate });

    const handleCloseDrawer = useCallback(() => {
        setOpen('');
    }, [setOpen]);

    const currentRadiologicalEquipment = transformedRadilogicalEquipments.find(
        (item: any) => item?.id === selectedRadiologicalEquipment?.id
    );

    const handleTabChange = useCallback(
        (_event: React.SyntheticEvent, newValue: EQUIPMENT_TAB_INDEX) => {
            setCurrentTab(newValue);
        },
        []
    );

    useEffect(() => {
        if (open) {
            setCurrentTab(EQUIPMENT_TAB_INDEX.EQUIPMENT);
        }
    }, [open]);

    // Memoize the drawer props to prevent unnecessary re-renders
    const drawerProps = {
        handleCloseDrawer,
        selectedRadiologicalEquipment: currentRadiologicalEquipment,
        translate,
        currentTab,
        setCurrentTab,
        handleTabChange
    };

    return (
        <DrawerSvcc
            open={!!open}
            ancho={720}
            onClose={() =>
                onlyVisual
                    ? handleCloseDrawer()
                    : closeWithoutSavingAlert({ confirmAction: () => setOpen('') })
            }
        >
            {open === RADIOLGICAL_EQUIPMENT_DRAWER_ACTION_VALUES.NEW_RADIOLGICAL_EQUIPMENT && (
                <NewRadiologicalEquipmentDrawer
                    {...drawerProps}
                    onlyVisual={onlyVisual}
                    isEditing={false}
                    handleCancelClick={() =>
                        onlyVisual
                            ? handleCloseDrawer()
                            : closeWithoutSavingAlert({ confirmAction: () => setOpen('') })
                    }
                />
            )}
            {open === RADIOLGICAL_EQUIPMENT_DRAWER_ACTION_VALUES.EDIT_RADIOLGICAL_EQUIPMENT && (
                <NewRadiologicalEquipmentDrawer
                    {...drawerProps}
                    onlyVisual={onlyVisual}
                    isEditing={true}
                    handleCancelClick={() =>
                        onlyVisual
                            ? handleCloseDrawer()
                            : closeWithoutSavingAlert({ confirmAction: () => setOpen('') })
                    }
                />
            )}
        </DrawerSvcc>
    );
};

export default DrawerManager;
